// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CodelistValue } from './codelist-value';
import {
    CodelistValueFromJSON,
    CodelistValueFromJSONTyped,
    CodelistValueToJSON,
    CodelistValueToJSONTyped,
} from './codelist-value';
import type { CodelistCondition } from './codelist-condition';
import {
    CodelistConditionFromJSON,
    CodelistConditionFromJSONTyped,
    CodelistConditionToJSON,
    CodelistConditionToJSONTyped,
} from './codelist-condition';

/**
 * 
 * @export
 * @interface CodelistItem
 */
export interface CodelistItem {
    /**
     * 
     * @type {string}
     * @memberof CodelistItem
     */
    column: string;
    /**
     * 
     * @type {Array<CodelistCondition>}
     * @memberof CodelistItem
     */
    conditions?: Array<CodelistCondition>;
    /**
     * 
     * @type {boolean}
     * @memberof CodelistItem
     */
    extensible?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CodelistItem
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CodelistItem
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CodelistItem
     */
    severity?: CodelistItemSeverityEnum;
    /**
     * 
     * @type {string}
     * @memberof CodelistItem
     */
    source?: string;
    /**
     * 
     * @type {string}
     * @memberof CodelistItem
     */
    source_id?: string | null;
    /**
     * 
     * @type {Array<CodelistValue>}
     * @memberof CodelistItem
     */
    values: Array<CodelistValue>;
}


/**
 * @export
 */
export const CodelistItemSeverityEnum = {
    Minor: 'minor',
    Major: 'major'
} as const;
export type CodelistItemSeverityEnum = typeof CodelistItemSeverityEnum[keyof typeof CodelistItemSeverityEnum];


/**
 * Check if a given object implements the CodelistItem interface.
 */
export function instanceOfCodelistItem(value: object): value is CodelistItem {
    if (!('column' in value) || value['column'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('values' in value) || value['values'] === undefined) return false;
    return true;
}

export function CodelistItemFromJSON(json: any): CodelistItem {
    return CodelistItemFromJSONTyped(json, false);
}

export function CodelistItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): CodelistItem {
    if (json == null) {
        return json;
    }
    return {
        
        'column': json['column'],
        'conditions': json['conditions'] == null ? undefined : ((json['conditions'] as Array<any>).map(CodelistConditionFromJSON)),
        'extensible': json['extensible'] == null ? undefined : json['extensible'],
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'],
        'severity': json['severity'] == null ? undefined : json['severity'],
        'source': json['source'] == null ? undefined : json['source'],
        'source_id': json['source_id'] == null ? undefined : json['source_id'],
        'values': ((json['values'] as Array<any>).map(CodelistValueFromJSON)),
    };
}

export function CodelistItemToJSON(json: any): CodelistItem {
    return CodelistItemToJSONTyped(json, false);
}

export function CodelistItemToJSONTyped(value?: CodelistItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'column': value['column'],
        'conditions': value['conditions'] == null ? undefined : ((value['conditions'] as Array<any>).map(CodelistConditionToJSON)),
        'extensible': value['extensible'],
        'id': value['id'],
        'name': value['name'],
        'severity': value['severity'],
        'source': value['source'],
        'source_id': value['source_id'],
        'values': ((value['values'] as Array<any>).map(CodelistValueToJSON)),
    };
}
